export const FIDELIDADE_RESUMO_RANKING_CASHBACK =
  "FIDELIDADE_RESUMO_RANKING_CASHBACK";
export const FIDELIDADE_RESUMO_RANKING_TRANSACOES =
  "FIDELIDADE_RESUMO_RANKING_TRANSACOES";
export const FIDELIDADE_RESUMO_RANKING_ANIVERSARIANTES =
  "FIDELIDADE_RESUMO_RANKING_ANIVERSARIANTES";
export const FIDELIDADE_RESUMO_RANKING_VENCIMENTOS =
  "FIDELIDADE_RESUMO_RANKING_VENCIMENTOS";
export const FIDELIDADE_RESUMO_LOADING = "FIDELIDADE_RESUMO_LOADING";
